"use client";
import { PatientDetailsDrawer } from "./patient-details-drawer";
import { usePatientStore } from "../store/usePatientStore";

export function GlobalPatientDetailsDrawer() {
  const selectedPatient = usePatientStore((s) => s.selectedPatient);
  const setSelectedPatient = usePatientStore((s) => s.setSelectedPatient);

  return (
    <PatientDetailsDrawer
      patientId={selectedPatient?.id ?? null}
      initialData={selectedPatient?.initialData}
      onClose={() => setSelectedPatient(null)}
    />
  );
}
